import { useEffect, useState } from 'react';

import { Brand, BrandOnDark } from './Brand';
import { Link } from '../router';
import { endpoints } from '../config';

export const pages = [
  { path: '/', label: 'Home' },
  { path: '/products', label: 'Products' },
  { path: '/solutions', label: 'Solutions' },
  { path: '/pricing', label: 'Pricing' },
  { path: '/resources', label: 'Resources' },
  { path: '/company', label: 'Company' },
];

export function Header({
  path,
  navigate,
}: {
  path: string;
  navigate: (to: string) => void;
}) {
  const [open, setOpen] = useState(false);

  // A menu left open across a navigation covers the page somebody just asked for.
  useEffect(() => setOpen(false), [path]);

  const go = (to: string) => {
    setOpen(false);
    navigate(to);
  };

  return (
    <header className="header">
      <div className="wrap header__inner">
        <Brand href="/" />

        <button
          type="button"
          className="nav__toggle"
          aria-expanded={open}
          aria-controls="site-nav"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? 'Close' : 'Menu'}
        </button>

        <nav id="site-nav" className={`nav${open ? ' nav--open' : ''}`} aria-label="Main">
          {pages.map((page) => (
            <Link
              key={page.path}
              to={page.path}
              onNavigate={go}
              className={`nav__link${path === page.path ? ' nav__link--active' : ''}`}
            >
              {page.label}
            </Link>
          ))}

          <span className="nav__actions">
            <a className="btn btn--ghost" href={endpoints.signIn}>
              Sign in
            </a>
          </span>
        </nav>

        {/*
          Outside the collapsible menu on purpose. On a phone the whole nav folds away, and it
          took the one action the page exists for with it — somebody who had decided to sign up
          had to open a menu to find out how. This stays put at every width.
        */}
        <span className="header__cta">
          <Link to="/signup" onNavigate={go} className="btn btn--primary">
            Create account
          </Link>
        </span>
      </div>
    </header>
  );
}

export function Footer({ navigate }: { navigate: (to: string) => void }) {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="wrap">
        <div className="grid grid--4">
          <div className="footer__brand">
            <div style={{ marginBottom: 14 }}>
              <BrandOnDark />
            </div>
            <p style={{ margin: 0 }}>
              One account, one sign-in, and the applications your organisation actually needs.
            </p>
          </div>

          <div>
            <h4>Product</h4>
            <Link to="/products" onNavigate={navigate}>
              Applications
            </Link>
            <Link to="/solutions" onNavigate={navigate}>
              Solutions
            </Link>
            <Link to="/pricing" onNavigate={navigate}>
              Pricing
            </Link>
          </div>

          <div>
            <h4>Resources</h4>
            <Link to="/resources" onNavigate={navigate}>
              Help centre
            </Link>
            <Link to="/resources" onNavigate={navigate}>
              API documentation
            </Link>
            <Link to="/resources" onNavigate={navigate}>
              Security
            </Link>
          </div>

          <div>
            <h4>Company</h4>
            <Link to="/company" onNavigate={navigate}>
              About SJS Tech
            </Link>
            <Link to="/company" onNavigate={navigate}>
              Contact
            </Link>
            <Link to="/signup" onNavigate={navigate}>
              Create account
            </Link>
            <a href={endpoints.signIn}>Sign in</a>
          </div>
        </div>

        <div className="footer__bar">
          <span>© {year} SJS Tech. ClientMa is a product of SJS Tech.</span>
          <span>India · Singapore · Malaysia</span>
        </div>
      </div>
    </footer>
  );
}
